import React, { useEffect, useState } from 'react';
import './CommunityItemOrders.scss';
import { FxDate, FxSelect, FxDateDisplay, FxCurrency, http, formatService, useNavigationService, localstorage, FxDateTimeDisplay, FxTime } from '../../fx-core';
import * as _ from 'lodash';
import { Button, Card, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, Breadcrumbs, Typography, Tabs, Tab, Box, TablePagination } from '@material-ui/core';
import CommunityItemOrderDetail from '../CommunityItemOrderDetail/CommunityItemOrderDetail';
import { NoRecords } from '../../NoRecords/NoRecords';
import { mkConfig, generateCsv, download } from "export-to-csv";
import { FxTimeDisplay } from '../../fx-core/FxTimeDisplay/FxTimeDisplay ';
import StallBookingDetail from '../../Provider/StallBookingDetail/StallBookingDetail';

const CommunityItemOrders = (props: any) => {
  const { routeData, back } = useNavigationService();

  // State for active tab
  const [activeTab, setActiveTab] = useState(0);

  // Tab change handler
  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <div className="communityitemorders-ui pt-5">
      <div className="content-container">
        <div className="content">
          <div className="title-font-breadcrumbs custom-head pl-4 pt-4">
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="primary" className="custom-link pointer breadcrumbs-style" onClick={back}>
                <b>{routeData.communityName}</b>
              </Link>
              <Typography color="primary" className="breadcrumbs-style">
                {activeTab === 0 ? 'Orders' : 'Bookings'}
              </Typography>
            </Breadcrumbs>
          
          </div>

          {/* Tabs */}
       <div className="px-4" style={{ display: 'flex', justifyContent: 'center' }}>
  <Tabs 
    value={activeTab} 
    onChange={handleTabChange}
    indicatorColor="primary"
    textColor="primary"
  >
    <Tab label="Items" />
    <Tab label="Bookings" />
  </Tabs>
</div>

          {/* Tab Content */}
          <div className="tab-content">
            {activeTab === 0 && <ItemsTab routeData={routeData} back={back} />}
            {activeTab === 1 && <BookingsTab routeData={routeData} back={back} />}
          </div>
        </div>
      </div>
    </div>
  );
};

// Items Tab Component
const ItemsTab = (props: any) => {
  const { routeData, back } = props;

  let defaultFilter: any = {
    fromDate: formatService.getYearStartDate(),
    toDate: formatService.getCurrentDateForServer(),
    orderStatusId: -1,
    stallId: -1,
    communityId: routeData.communityId
  };
  const initialList: any[] = [];

  const [orderList, setOrderList] = useState<any[]>(initialList);
  const [open, setOpen] = useState<boolean>(false);
  const [orderId, setOrderId] = useState<number>(0);
  const [filter, setFilter] = useState<any>(defaultFilter);
  const [orderStatus, setOrderStatus] = useState<any[]>(initialList);
  const [stalls, setStalls] = useState<any[]>(initialList);
  const [communityList, setCommunityList] = useState<any[]>([]);

  // Pagination (client-side)
  const [page, setPage] = useState(0);
  const rowsPerPage = 50;
  const [totalOrders, setTotalOrders] = useState(0);
  const [ordersLoading, setOrdersLoading] = useState(false);

  const handleInputChange = (item: any) => {
    handleFilterChange({ [item.name]: item.value });
    let filterObj = {
      fromDate: filter.fromDate,
      toDate: filter.toDate,
      orderStatusId: filter.orderStatusId,
      stallId: filter.stallId,
      communityId: filter.communityId
    }
    if (item.name == "fromDate") {
      filterObj.fromDate = formatService.getDateStringForServer(item.value);
    }
    else if (item.name == "toDate") {
      filterObj.toDate = formatService.getDateStringForServer(item.value);
    }
    else if (item.name == "orderStatusId") {
      filterObj.orderStatusId = item.value;
    }
    else if (item.name == "stallId") {
      filterObj.stallId = item.value;
    }
    else if (item.name == 'communityId') {
      filterObj.communityId = item.value;
      initLookup(filterObj.communityId);
    }
    getOrderList(filterObj);
  };

  const handleFilterChange = (data: any) => {
    setFilter((prevState: any) => {
      return { ...prevState, ...data }
    });
  };

  const getOrderList = (filters: any) => {
    let inputData = {
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      stallId: filters.stallId,
      orderStatusId: filters.orderStatusId,
      communityId: filters.communityId
    };
    let apiOptions: any = {
      url: 'order/all/dashboard',
      data: inputData
    };
    http.post(apiOptions).then((res: any) => {
      getOrderListCallBack(res);
    })
  };

  const getOrderListCallBack = (res: any) => {
    const items = res.data || [];
    setOrderList(Array.isArray(items) ? items : []);
    setTotalOrders(Array.isArray(items) ? items.length : 0);
    setPage(0);
  };

  const viewOrderDetail = (item: any) => {
    setOpen(true);
    setOrderId(item.id);
  };

  const handleClose = () => {
    setOpen(false);
    setOrderId(0);
  };

  const initLookup = (communityId: any) => {
    let inputData = {
      lookups: {
        OrderStatus: { default: true },
        Stalls: { default: true }
      },
      filters: {
        communityId: communityId,
        tier4Flag: true
      }
    };
    let apiOptions = {
      url: 'options/lookup',
      data: inputData
    };
    http.post(apiOptions).then((res: any) => {
      lookupCallBack(res);
    });
  };

  const lookupCallBack = (res: any) => {
    let orderStatusRes = res.data.OrderStatus;
    let stalls = res.data.Stalls;
    if (orderStatusRes.length > 0) {
      let itemIdx = _.findIndex(orderStatusRes, { code: "Processing" });
      orderStatusRes.splice(itemIdx, 1);
      setOrderStatus(orderStatusRes);
    }
    setStalls(stalls);
  };

  const navToBack = () => {
    back();
  }

  const getMyRegionCommunities = () => {
    let inputData = {
      lookups: {
        MyRegionCommunities: { default: false }
      },
      filters: {
        userId: localstorage.getItem("userId")
      }
    };
    let apiOptions = {
      url: 'options/lookup',
      data: inputData
    };
    http.post(apiOptions).then(response => {
      getMyRegionCommunitiesCallBack(response);
    })
  };

  const getMyRegionCommunitiesCallBack = (res: any) => {
    let result = res.data;
    setCommunityList(result.MyRegionCommunities || []);
  };

  const getMyZoneCommunities = () => {
    let inputData = {
      lookups: {
        MyZoneCommunities: { default: false }
      },
      filters: {
        userId: localstorage.getItem("userId")
      }
    };
    let apiOptions = {
      url: 'options/lookup',
      data: inputData
    };
    http.post(apiOptions).then(response => {
      getMyZoneCommunitiesCallBack(response);
    })
  }

  const getMyZoneCommunitiesCallBack = (res: any) => {
    let result = res.data;
    setCommunityList(result.MyZoneCommunities || []);
  };

  const getMyAdminCommunities = () => {
    let apiOptions: any = {
      url: 'community/role/list',
      data: {}
    };
    http.post(apiOptions).then(res => { getMyAdminCommunitiesCallBack(res) });
  };

  const getMyAdminCommunitiesCallBack = (res: any) => {
    let result = res.data || [];
    let commuArr: any = [];
    for (let item of result) {
      let itemObj: any = {
        id: item.id,
        text: item.name
      };
      commuArr.push(itemObj);
    }
    setCommunityList(commuArr);
  };

  const initCalls = () => {
    if (routeData.parent == 'REGIONALMANAGER') {
      getMyRegionCommunities();
    }
    else if (routeData.parent == 'ZONALMANAGER') {
      getMyZoneCommunities();
    }
    else if (routeData.parent == 'COMMADMIN') {
      getMyAdminCommunities();
    }
  }

  const csvConfig = mkConfig({
    filename: 'community_orders',
    useKeysAsHeaders: true,
    quoteStrings: true,
  });
  
  const csvData = orderList.map((order: any) => ({
  date: order.placedDate ? formatService.getDateStringForServer(order.placedDate) : "",
  shop: order.stallName || "",
  deliveryType: order.orderTypeId === 1 ? "Delivery" : order.orderTypeId === 2 ? "Pickup" : "",
  deliveryDate: order.orderDate ? formatService.getDateStringForServer(order.orderDate) : "",
  customer: order.customerName ? order.customerName : (order.consumerName || ""),
  phone: order.consumerPhone ? '="' + order.consumerPhone + '"' : "",
  community: order.communityName || "",
  orderId: order.orderIdentifier ? "#" + order.orderIdentifier : "",
  status: order.orderStatus || "",
  amount: order.orderTotal || "",
  couponAmount: order.couponAmount || "",
  deliveryCharge: order.deliveryCharge || "",
  finalAmount: order.orderTotal || "",
  paymentMode: order.orderPayments ? order.orderPayments.map((p: any) => p.paymentMode).join(", ") : "",
  paymentStatus: order.orderPayments ? order.orderPayments.map((p: any) => p.paymentStatus).join(", ") : "",
  treasureHunt: order.isTreasureHunt === 1 ? "Winner" : "Not winner",
}));

  useEffect(() => {
    initCalls();
    initLookup(filter.communityId);
    getOrderList(filter);
  }, []);

  // Client-side slice for orders
  const paginatedOrders = orderList.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

  return (
    <div>
      {/* Desktop View */}
      <div className='deskview'>
        <div className="row mt-2 px-5 justify-content-between">
          <div className="col-2 px-0">
            <FxDate
              name="fromDate"
              variant="standard"
              size="small"
              label="From Date"
              value={filter.fromDate}
              onValueChange={handleInputChange}
            />
          </div>
          <div className="col-2 px-0">
            <FxDate
              name="toDate"
              variant="standard"
              size="small"
              label="To Date"
              value={filter.toDate}
              onValueChange={handleInputChange}
            />
          </div>
          <div className="col-2 px-0 pt-4">
            <FxSelect name="orderStatusId" variant="outlined" label="Order Status"
              options={orderStatus}
              selectedValue={filter.orderStatusId}
              valueField="id"
              displayField="text"
              size="small"
              style={{ width: 260 }}
              onValueChange={handleInputChange} />
          </div>
          <div className="col-2 px-0 pt-4">
            <FxSelect name="stallId" variant="outlined" label="Stall"
              options={stalls}
              selectedValue={filter.stallId}
              valueField="id"
              displayField="text"
              size="small"
              style={{ width: 260 }}
              onValueChange={handleInputChange} />
          </div>
          <div className='col-2 px-0 pt-4'>
            <FxSelect name="communityId" variant="outlined"
              label="Community"
              options={communityList}
              selectedValue={filter.communityId}
              valueField="id"
              displayField="text"
              size="small"
              style={{ width: 260 }}
              onValueChange={handleInputChange} />
          </div>
        </div>

        <div className='my-4 mx-4'>
          <button
                className="btn btn-primary mb-3"
                onClick={() => {
                  const csv = generateCsv(csvConfig)(csvData);
                  download(csvConfig)(csv);
                }}
              >
                Download All Users as CSV
              </button>
              
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: '8px' }}>
            <TablePagination
              count={orderList.length}
              page={page}
              onPageChange={(e: any, newPage: number) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[50]}
              
              onRowsPerPageChange={(e: any) => {}}
              labelDisplayedRows={({ from, to, count }: { from: number; to: number; count: number }) => `Showing ${from}-${to} of ${count}`}
            />
          </div>
          <TableContainer component={Paper}>
            <Table size="small" className='table-striped'>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Time</TableCell>
                  <TableCell>Shop</TableCell>
                  <TableCell>Delivery Type</TableCell>
                  <TableCell>Delivery Date</TableCell>
                  <TableCell>Customer</TableCell>
                  <TableCell>Community</TableCell>
                  <TableCell className='text-right'>Order#</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell className='text-right'>Amount</TableCell>
                  <TableCell>Payment</TableCell>
                  <TableCell>Treasure Hunt</TableCell>
                  <TableCell>Detail</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {orderList.length == 0 &&
                  <TableCell colSpan={10}>
                    <NoRecords />
                  </TableCell>
                }
                {orderList.length > 0 && paginatedOrders.map((row: any, i) => (
                  <TableRow key={page * rowsPerPage + i}>
                    <TableCell><FxDateDisplay value={row.placedDate} /></TableCell>
                    <TableCell><FxTimeDisplay value={row.placedDate} /></TableCell>
                    <TableCell>{row.stallName}</TableCell>
                    <TableCell>
                      {row.orderTypeId == 1 &&
                        <span>Delivery</span>
                      }
                      {row.orderTypeId == 2 &&
                        <span>Pickup</span>
                      }
                    </TableCell>
                    <TableCell><FxDateDisplay value={row.orderDate} /></TableCell>
                    <TableCell>
                      <div className='row'>
                        <span>{row.customerName ? row.customerName : row.consumerName}</span>
                        <span className='pl-2'>{row.consumerPhone}</span>
                      </div>
                    </TableCell>
                    <TableCell>
                      <span>{row.communityName}</span>
                    </TableCell>
                    <TableCell className='text-right'>#{row.orderIdentifier}</TableCell>
                    <TableCell>
                      {row.orderStatus}
                      {
                        row.orderStatus === 'Cancelled' &&
                        <span className='pl-2'>({row.cancelledRemarks})</span>
                      }
                    </TableCell>
                    <TableCell className='text-right'>
                      <FxCurrency value={row.orderTotal} />
                    </TableCell>
                    <TableCell>
                      {row.orderPayments && row.orderPayments.map((itemObj: any, i: number) => (
                        <div key={i}>
                          {itemObj.paymentMode == 'cod' &&
                            <span className='payment-style'>
                              Cash / {itemObj.paymentStatus}
                            </span>
                          }
                          {itemObj.paymentMode == 'stripe' &&
                            <span className='payment-style'>
                              {'Card :' + itemObj.paymentStatus}
                            </span>
                          }
                          {itemObj.paymentMode != 'cod' && itemObj.paymentMode != 'stripe' &&
                            <span className='payment-style'>
                              {itemObj.paymentMode} / {itemObj.paymentStatus}
                            </span>
                          }
                        </div>
                      ))
                      }
                    </TableCell>
                    <TableCell>
                      {
                        row.isTreasureHunt === 1 ? <span>Winner</span> :<span>Not winner</span>
                      }
                    </TableCell>
                    <TableCell>
                      <Button variant='outlined' size='small' className='button-style' onClick={() => viewOrderDetail(row)}>View Order</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </div>
      </div>

      {/* Dialog for order details */}
      <div>
        <Dialog
          open={open}
          maxWidth="md"
          fullWidth
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <CommunityItemOrderDetail orderId={orderId} handleClose={handleClose} />
        </Dialog>
      </div>
    </div>
  );
};

// Bookings Tab Component
const BookingsTab = (props: any) => {
  const { routeData, back } = props;

  // Clean default filter
  const getDefaultFilter = () => ({
    stallBookingDate: "",
    bookingRequestStatusId: -1,
    stallId: -1,
    communityId: routeData?.communityId || 20052,
    stallBookingId: -1
  });

  const [bookingList, setBookingList] = useState<any[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [bookingId, setBookingId] = useState<number>(0);
  const [filter, setFilter] = useState<any>(getDefaultFilter());
  const [bookingRequestStatus, setBookingRequestStatus] = useState<any[]>([]);
  const [stalls, setStalls] = useState<any[]>([]);
  const [communityList, setCommunityList] = useState<any[]>([]);

  // Pagination (client-side)
  const [bookingPage, setBookingPage] = useState(0);
  const bookingRowsPerPage = 50;
  const [totalBookings, setTotalBookings] = useState(0);
  const [bookingsLoading, setBookingsLoading] = useState(false);

  const handleInputChange = (item: any) => {
    let filterObj: any = { ...filter };
    
    if (item.name === "stallBookingDate") {
      filterObj.stallBookingDate = item.value ? formatService.getDateStringForServer(item.value) : "";
    } else if (item.name === "communityId") {
      filterObj.communityId = item.value;
      filterObj.stallId = -1;
      filterObj.bookingRequestStatusId = -1;
      filterObj.stallBookingDate = "";
      initLookup(item.value);
    } else {
      filterObj[item.name] = item.value;
    }

    setFilter(filterObj);
    getBookingList(filterObj);
  };

  const getBookingList = (filters: any) => {
    let inputData: any = {
      stallId: filters.stallId,
      stallBookingId: filters.stallBookingId,
      stallBookingDate: filters.stallBookingDate,
      bookingRequestStatusId: filters.bookingRequestStatusId,
      communityId: filters.communityId
    };

    let apiOptions: any = {
      url: 'stallbookingrequest/stallwise-list',
      data: inputData
    };

    http.post(apiOptions).then((res: any) => {
      getBookingListCallBack(res);
    }).catch((error: any) => {
      console.error("❌ Booking API Error:", error);
      setBookingList([]);
    });
  };

  const getBookingListCallBack = (res: any) => {
    const items = res.data || [];
    setBookingList(Array.isArray(items) ? items : []);
    setTotalBookings(Array.isArray(items) ? items.length : 0);
    setBookingPage(0);
  };

  const viewBookingDetail = (item: any) => {
    setOpen(true);
    setBookingId(item.id);
  };

  const handleClose = () => {
    setOpen(false);
    setBookingId(0);
  };

  const initLookup = (communityId: any) => {
    let inputData = {
      lookups: {
        BookingRequestStatus: { default: true },
        Stalls: { default: true }
      },
      filters: {
        communityId: communityId,
        tier4Flag: true
      }
    };

    let apiOptions = {
      url: 'options/lookup',
      data: inputData
    };

    http.post(apiOptions).then((res: any) => {
      lookupCallBack(res);
    }).catch((error: any) => {
      console.error("❌ Lookup Error:", error);
    });
  };

  const lookupCallBack = (res: any) => {
    if (res && res.data) {
      let bookingStatusRes = res.data.BookingRequestStatus || [];
      let stallsRes = res.data.Stalls || [];
      
      setBookingRequestStatus(bookingStatusRes);
      setStalls(stallsRes);
    }
  };

  const navToBack = () => {
    back();
  };

  const getMyRegionCommunities = () => {
    let inputData = {
      lookups: {
        MyRegionCommunities: { default: false }
      },
      filters: {
        userId: localstorage.getItem("userId")
      }
    };
    let apiOptions = {
      url: 'options/lookup',
      data: inputData
    };
    http.post(apiOptions).then(response => {
      setCommunityList(response.data.MyRegionCommunities || []);
    });
  };

  const getMyZoneCommunities = () => {
    let inputData = {
      lookups: {
        MyZoneCommunities: { default: false }
      },
      filters: {
        userId: localstorage.getItem("userId")
      }
    };
    let apiOptions = {
      url: 'options/lookup',
      data: inputData
    };
    http.post(apiOptions).then(response => {
      setCommunityList(response.data.MyZoneCommunities || []);
    });
  };

  const getMyAdminCommunities = () => {
    let apiOptions: any = {
      url: 'community/role/list',
      data: {}
    };
    http.post(apiOptions).then(res => {
      let result = res.data || [];
      let commuArr: any = [];
      for (let item of result) {
        commuArr.push({
          id: item.id,
          text: item.name
        });
      }
      setCommunityList(commuArr);
    });
  };

  const initCalls = () => {
    if (routeData.parent === 'REGIONALMANAGER') {
      getMyRegionCommunities();
    } else if (routeData.parent === 'ZONALMANAGER') {
      getMyZoneCommunities();
    } else if (routeData.parent === 'COMMADMIN') {
      getMyAdminCommunities();
    }
  };

  const csvConfig = mkConfig({
    filename: 'community_bookings',
    useKeysAsHeaders: true,
    quoteStrings: true,
  });

  const csvData = bookingList.map((booking: any) => ({
    bookingDate: booking.bookingDate || "",
    bookingTime: booking.bookingTime || "",
    stallName: booking.stallName || "",
    bookingName: booking.bookingName || "",
    contactName: booking.contactName || "",
    contactNumber: booking.contactNumber ? '="' + booking.contactNumber + '"' : "",
    seatCount: booking.seatCount || "",
    bookingRequestIdentifier: booking.bookingRequestIdentifier || "",
    bookingRequestStatus: booking.bookingRequestStatus || "",
    amount: booking.amount || "",
    paymentMode: booking.bookingPayments ? booking.bookingPayments.map((p: any) => p.paymentMode).join(", ") : "",
    paymentStatus: booking.bookingPayments ? booking.bookingPayments.map((p: any) => p.paymentStatus).join(", ") : "",
    requestNotes: booking.requestNotes || "",
  }));

  useEffect(() => {
    const defaultFilter = getDefaultFilter();
    setFilter(defaultFilter);
    initCalls();
    initLookup(defaultFilter.communityId);
    getBookingList(defaultFilter);
  }, []);

  // Client-side slice for bookings
  const paginatedBookings = bookingList.slice(bookingPage * bookingRowsPerPage, (bookingPage + 1) * bookingRowsPerPage);

  return (
    <div>
      {/* Desktop View */}
      <div className='deskview'>
        <div className="row mt-2 px-5 justify-content-between">
          <div className="col-2 px-0">
            <FxDate
              name="stallBookingDate"
              variant="standard"
              size="small"
              label="Booking Date"
              value={filter.stallBookingDate}
              onValueChange={handleInputChange}
            />
          </div>
          <div className="col-2 px-0 pt-4">
            <FxSelect
              name="bookingRequestStatusId"
              variant="outlined"
              label="Booking Status"
              options={bookingRequestStatus}
              selectedValue={filter.bookingRequestStatusId}
              valueField="id"
              displayField="text"
              size="small"
              style={{ width: 260 }}
              onValueChange={handleInputChange}
            />
          </div>
          <div className="col-2 px-0 pt-4">
            <FxSelect
              name="stallId"
              variant="outlined"
              label="Stall"
              options={stalls}
              selectedValue={filter.stallId}
              valueField="id"
              displayField="text"
              size="small"
              style={{ width: 260 }}
              onValueChange={handleInputChange}
            />
          </div>
          <div className='col-2 px-0 pt-4'>
            <FxSelect
              name="communityId"
              variant="outlined"
              label="Community"
              options={communityList}
              selectedValue={filter.communityId}
              valueField="id"
              displayField="text"
              size="small"
              style={{ width: 260 }}
              onValueChange={handleInputChange}
            />
          </div>
        </div>

        <div className='my-4 mx-4'>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <button
              className="btn btn-primary"
              onClick={() => {
                const csv = generateCsv(csvConfig)(csvData);
                download(csvConfig)(csv);
              }}
            >
              Download Bookings as CSV
            </button>
            {/* <div className="text-muted">
              Showing {bookingList.length} booking{bookingList.length !== 1 ? 's' : ''}
            </div> */}
          </div>
               <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: '8px' }}>
            <TablePagination
              count={bookingList.length}
              page={bookingPage}
              onPageChange={(e: any, newPage: number) => setBookingPage(newPage)}
              rowsPerPage={bookingRowsPerPage}
              rowsPerPageOptions={[50]}
              onRowsPerPageChange={(e: any) => {}}
              labelDisplayedRows={({ from, to, count }: { from: number; to: number; count: number }) => `Showing ${from}-${to} of ${count}`}
            />
          </div>

          <TableContainer component={Paper}>
            <Table size="small" className='table-striped'>
              <TableHead>
                <TableRow>
                  <TableCell> Date</TableCell>
                  <TableCell> Time</TableCell>
                  <TableCell>Stall</TableCell>
                  <TableCell>Booking Name</TableCell>
                  <TableCell>Contact Name</TableCell>
                  <TableCell>Mobile</TableCell>
                  <TableCell>Seat Count</TableCell>
                  <TableCell className='text-right'>Booking #</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell >Amount</TableCell>
                  <TableCell>Payment</TableCell>
                  <TableCell>Detail</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bookingList.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <NoRecords />
                    </TableCell>
                  </TableRow>
                )}
                {bookingList.length > 0 && paginatedBookings.map((row: any, i) => (
                  <TableRow key={bookingPage * bookingRowsPerPage + i}>
                    <TableCell><FxDateDisplay value={row.createdDate} /></TableCell>
                    <TableCell><FxTimeDisplay value={row.createdDate} format="hh:mm A" /></TableCell>
                    <TableCell>{row.stallName}</TableCell>
                    <TableCell>{row.bookingName}</TableCell>
                    <TableCell>{row.contactName}</TableCell>
                    <TableCell>{row.contactNumber}</TableCell>
                    <TableCell>{row.seatCount}</TableCell>
                    <TableCell className='text-right'>#{row.bookingRequestIdentifier}</TableCell>
                    <TableCell>
                      {row.bookingRequestStatus}
                      {/* {row.comments && (
                        <span className='pl-2'>({row.comments})</span>
                      )} */}
                    </TableCell>
                    <TableCell className='text-right'>
                      <FxCurrency value={row.amount} />
                    </TableCell>
                    <TableCell>
                      {row.bookingPayments && row.bookingPayments.map((itemObj: any, idx: number) => (
                        <div key={idx}>
                          {itemObj.paymentMode === 'cod' && (
                            <span className='payment-style'>
                              Cash / {itemObj.paymentStatus}
                            </span>
                          )}
                          {itemObj.paymentMode === 'stripe' && (
                            <span className='payment-style'>
                              Card : {itemObj.paymentStatus}
                            </span>
                          )}
                          {itemObj.paymentMode === 'coupon' && (
                            <span className='payment-style'>
                              Coupon : {itemObj.paymentStatus}
                            </span>
                          )}
                          {itemObj.paymentMode === 'razorpay' && (
                            <span className='payment-style'>
                              Razorpay : {itemObj.paymentStatus}
                            </span>
                          )}
                          {!['cod', 'stripe', 'coupon', 'razorpay'].includes(itemObj.paymentMode) && (
                            <span className='payment-style'>
                              {itemObj.paymentMode} / {itemObj.paymentStatus}
                            </span>
                          )}
                        </div>
                      ))}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant='outlined'
                        size='small'
                        className='button-style'
                        onClick={() => viewBookingDetail(row)}
                      >
                        View Details
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

     
        </div>
      </div>

      {/* Dialog for booking details */}
      <div>
        <Dialog
          open={open}
          maxWidth="md"
          fullWidth
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <StallBookingDetail id={bookingId} handleClose={handleClose} />
        </Dialog>
      </div>
    </div>
  );
};

export default CommunityItemOrders;